import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Copy, Users, Gift } from "lucide-react";

export default function Referral() {
  const [info, setInfo] = useState(null);

  useEffect(() => { api.get("/referral").then(r => setInfo(r.data)); }, []);

  if (!info) return <div className="p-8 text-gray-400">Loading…</div>;

  const link = `${window.location.origin}/auth?ref=${info.code}`;
  const copy = () => { navigator.clipboard.writeText(link); toast.success("Link copied."); };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: "I Hate My Job", text: "Hate your job? This actually helped me find realistic paths out. Use my link to sign up:", url: link }); } catch {}
    } else copy();
  };

  return (
    <div className="max-w-2xl mx-auto px-5 pt-6">
      <div className="eyebrow text-[#FD0F10]">REFER A FRIEND</div>
      <h1 className="font-display text-3xl sm:text-4xl font-black mt-1">Share the way out.</h1>
      <p className="text-gray-400 text-sm mt-2">Every friend you refer who upgrades to Pro gives you <span className="text-white font-bold">30 days of Pro free</span>. Stackable. Cancel anytime.</p>

      <div className="mt-6 card-panel p-5">
        <div className="eyebrow text-[#FD0F10]">YOUR CODE</div>
        <div className="mt-2 font-mono-ui text-3xl font-bold tracking-widest text-white" data-testid="referral-code">{info.code}</div>
        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <input readOnly value={link} className="flex-1 bg-[#0B0C0E] border border-[#2A2E39] rounded px-4 py-2.5 text-xs font-mono-ui text-gray-300" data-testid="referral-link"/>
          <button onClick={copy} className="border border-[#2A2E39] px-4 py-2.5 rounded hover:border-white flex items-center gap-2" data-testid="referral-copy">
            <Copy size={16}/> Copy
          </button>
          <button onClick={share} className="hero-accent text-white font-bold px-4 py-2.5 rounded" data-testid="referral-share">
            Share
          </button>
        </div>
      </div>

      <div className="mt-6 grid sm:grid-cols-3 gap-3">
        <Stat icon={Users} label="FRIENDS REFERRED" value={info.referred_count}/>
        <Stat icon={Gift} label="UPGRADED" value={info.upgraded_count}/>
        <Stat icon={Gift} label="PENDING PRO DAYS" value={info.pending_referral_days || 0} note="Applied when your paid sub ends"/>
      </div>

      {info.premium_until && info.premium_source === "referral" && (
        <div className="mt-6 card-panel-elevated p-5">
          <div className="eyebrow text-[#FD0F10]">YOUR FREE PRO</div>
          <p className="mt-2 text-gray-200">Active until <span className="font-mono-ui text-white">{new Date(info.premium_until).toLocaleDateString()}</span></p>
        </div>
      )}
    </div>
  );
}

function Stat({ icon: Icon, label, value, note }) {
  return (
    <div className="card-panel p-4">
      <div className="flex items-center gap-2 text-[#FD0F10]"><Icon size={14}/><span className="eyebrow">{label}</span></div>
      <div className="font-display text-3xl font-black mt-2 text-white">{value}</div>
      {note && <div className="text-xs text-gray-400 mt-1">{note}</div>}
    </div>
  );
}
